// extracted by mini-css-extract-plugin
export default {"student_detailsPopup":"Modal_student_detailsPopup__OHZIO","imgbox":"Modal_imgbox__fEGsF","imgClass":"Modal_imgClass__jtzk8"};